module.exports = __webpack_public_path__ + "static/media/hygrostatykz.d1b5469e.pdf";